import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';
//import template = require('dojo/text!./AddressFinderHome.html');
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import { ProjectWizardV2 as ProjectWizard } from "../_loadingHelpers/VAMv2";
import { VAM2types as Types, VAMclassNames as Classnames, VAM2types, VAMclassNames } from "../_loadingHelpers/VAMv2Types";
import EvProjectCopyForm from '../ProjectWizard/CopyForm/EvProjectCopyForm';
import { EntityHelpers, ToasterHelpers } from "../../more/Helpers";
import ProjectReportOptionsForm from '../ProjectWizard/ProjectReportOptionsForm/ProjectReportOptionsForm';
import emailForm from '../EMail/emailForm';
import OrchestraMatrix from '../OrchestraMatrix/OrchestraMatrix';
import { SelectEntityDialog, SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import { EmailEditorTypes } from "../EMail/emailTypes";
import _WidgetBase from 'dijit/_WidgetBase';


class ProjectView extends compose(_EntityViewMixin<Types.EvProjectEntity_Base>) {
    //templateString = template; // nur falls nötig ein eigenes laden!
    private editor: MdsLax<InstanceType<typeof ProjectWizard>> = null;

    /**
    *
    * @param entityId
    * @param label
    * @param additionalParams
    * @param tabContainerName
    * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
    */
    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string,
        tabGroupHeadingLabel?: string,
        showAtNode?: HTMLElement
    ) {
        
        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        
        
        if (showAtNode) {
            this.showAtNode(entityId, label, showAtNode);
        } else {
            this.showAsDlg(entityId, label, tabContainerName, tabGroupHeadingLabel);
        }
    }


    onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {
        if (this.editingAllowed) {
            this.editor = new ProjectWizard();

            //// versuchen: Tab öffnen
            //if (this.createNewTabbedContent({
            //    enableClosing: true,
            //    name: entityID,
            //    sidebarEntryName: entityID,
            //    label: this.title,
            //    widget: this.editor,
            //    groupLabel: this.groupLabel,
            //    targetContainerName: this.tabContainerName
            //}, true, true) == true) {
            //    // Tab öffnen hat funktioniert
            //} else {
            //    let dlg = new GenericDialog();
            //    dlg.closeOnEnter = false;
            //    dlg.closeOnEscape = false;
            //    dlg._setTopCloseBtnAttr(true);
            //    dlg.keepOpen = true;
            //    //dlg.setUserdefinedButton(this.translations["AddressWizard__done"],
            //    //    null,
            //    //    lang.hitch(this, this._onWizardDone, dlg, this.editor))


            //    //dlg.enableContentOverflow(true);

            //    dlg.show(this.editor,
            //        this.title,
            //        null,
            //        null,
            //        "saveclose",
            //        lang.hitch(this, this._confirmCallback, dlg, this.editor));
            //}
            this.editor.startup();
            this.editor.show("tab", this.title, this.tabContainerName);

            this.editor.loadProjectById(this.entityID, this.title);
            //this.editor.startup();
            this.editor.on("deleted", lang.hitch(this, this.onDelete));



            //this.editor.on("saved", lang.hitch(this, this._onEditorSaved));


            return this.editor;
        }
    }

    private _onEditorSaved() {
        this.onEntityChange();
    }


    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }




    onShow() {
        this.handleAdditionalButtons();
    }


    private showMailEditor(subject?: string, content?: string, isBulkMail = false) {
        //TODO weniga gage email addresse rauspicken
        try {
            var targetMailForMailButton = this.viewData.content.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)[0];
        } catch {

        }
        this.mailform = new emailForm();
        this.mailform.setMailFormContext({
            isHistoryContext: true,
            contextEntity: {
                ID: this.entityID,
                Classname: this.config.entityClassname
            }
        });


        if (targetMailForMailButton && !isBulkMail) {
            this.mailform.addRecipients("to", [{ mailaddress: targetMailForMailButton, entityID: null }]);
        } else if (!isBulkMail) {
            this.mailform.loadRecipientAddress("to", this.entityID);
        }

        if (typeof subject == 'string') {
            this.mailform.setSubject(subject);
        }
        if (typeof content == 'string') {
            this.mailform.addContent(content);
        }

        this.mailform.show("dlg", null, this.getTabContainerName());

    }
    private handleAdditionalButtons() {

        if (this.hasUserRole(["OM", "OM_Matrix"])){
            this.addButton(
                "OM_Matrix",
                this.translations["OM__SchedulerMatrix"],
                lang.hitch(this, this._onClick_OpenOMMatrix),
                null,
                null,
                "fas fa-border-none",
                null,
                "left first",
                true
            );
        }

        if (this.hasFeature("Email", "ProjectView_CreateMail") && this.hasUserRole("Email_Editor")) {
            this.addButtonMenu("email", this.translate("General_Label_Email"), "fas fa-at", true, null);

            this.addButton("email",
                "email_mailFormStandalone_CreateNew",
                lang.hitch(this, this.showMailEditor, this.title),
                null,
                null,
                "fas fa-envelope-open-text",
                false,
                "left first",
                true,
                false,
                true,
                "email");


            if (this.hasFeature("Email", "ProjectView_BulkMail")) {
                this.addButtonMenu("bulkMailRelatedAddresses", this.translate("BulkMail_Label_RelatedAddresses"), "fas fa-sitemap", true, "email");
                this.addButtonMenu("bulkMailMusicianPlanning", this.translate("BulkMail_Label_MusicianPlanning"), "fas fa-guitar", true, "email");

                this.addButton("autoRelatedAddress", this.translate("BulkMail_Label_Auto"), lang.hitch(this, this._onClickBulkMailBtn, "project_relatedAddresses", true), null, null, "fas fa-mail-bulk", false, "left last", true, false, true, "bulkMailRelatedAddresses");
                this.addButton("selectRelatedAddress", this.translate("BulkMail_Label_Select"), lang.hitch(this, this._onClickBulkMailBtn, "project_relatedAddresses", false), null, null, "fas fa-mouse-pointer", false, "left last", true, false, true, "bulkMailRelatedAddresses");

                this.addButton("autoMusicianPlanning", this.translate("BulkMail_Label_Auto"), lang.hitch(this, this._onClickBulkMailBtn, "project_plannedMusicians", true), null, null, "fas fa-mail-bulk", false, "left last", true, false, true, "bulkMailMusicianPlanning");
                this.addButton("selectMusicianPlanning", this.translate("BulkMail_Label_Select"), lang.hitch(this, this._onClickBulkMailBtn, "project_plannedMusicians", false), null, null, "fas fa-mouse-pointer", false, "left last", true, false, true, "bulkMailMusicianPlanning");
            }

        }
        //if (this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"]) && this.entity && this.hasFeature("EvBooking/Copy")) {

        //    this.addButton(
        //        "copy",
        //        this.translations["BookingEditor__CopyEvBooking"],
        //        lang.hitch(this, this.startCloneProcess, this.entity),
        //        null,
        //        null,
        //        "fas fa-clone",
        //        false,
        //        "left last");
        //}

        if (!this.entity) {
            //this.disableButton("copy");
        }

        // Report-Download machen
        if (this.hasFeature("EvProject/ProjectReport")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: "General_Label_ProjectReport",
                    callback: lang.hitch(this, this.getProjectReport, "projectReport"),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("report",
                    "General_Label_ProjectReport",
                    lang.hitch(this, this.getProjectReport, "projectReport"),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }
        if (this.hasFeature("EvProject/ProjectReportShort")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: "General_Label_ProjectReportShort",
                    callback: lang.hitch(this, this.getProjectReport, "projectReportShort"),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("reportshort",
                    "General_Label_ProjectReportShort",
                    lang.hitch(this, this.getProjectReport, "projectReportShort"),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }
    }

    private _onClickBulkMailBtn(mode: string, autoSelect: boolean = true) {
        if (autoSelect) this.RequestManager.callfunction("Webtool_API_BulkMail_GetMailAddresses", { mode, entityId: this.entityID }, lang.hitch(this, this._onRequestEmailAddressesResponse), lang.hitch(this, this._onRequestEmailAddressesError));
        else this.RequestManager.callfunction("Webtool_API_BulkMail_SED_GetConfig", { mode }, lang.hitch(this, this._onSEDConfigResponse, mode), lang.hitch(this, this._onSEDConfigError));
    }

        private _onRequestEmailAddressesResponse(response: Array<UserEmail>) {
        this.StandbyStop();
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        for (let address of response) {
            mailAddressArray.push({ entityID: address.ID, mailaddress: address.telecom_code });
        }
        this.showMailEditor(this.title, null, true);
        this.mailform.setToBulkmail(null, mailAddressArray);
    }

    private _onRequestEmailAddressesError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onSEDConfigResponse(mode: string, response: SelectEntityDialogTypes.DlgConfiguration<any>) {
        let selectEntityDialog = new SelectEntityDialog();
        selectEntityDialog.setConfiguration(response, lang.hitch(this, this._onSEDCallback, mode));
        selectEntityDialog.addRequestParameter("mode", mode);
        selectEntityDialog.addRequestParameter("entityId", this.entityID);
        selectEntityDialog.show();
    }

    private _onSEDConfigError(error) {
        console.error(error);
    }

    private _onSEDCallback(mode: string, values: Array<string>, items: Array<SelectEntityDialogTypes.Item<UserEmail>>) {
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        switch (mode)
        {
            case "project_relatedAddresses":
            case "project_plannedMusicians":
                for (let item of items) {
                    mailAddressArray.push({ entityID: item.entry.data.ID, mailaddress: item.entry.data.telecom_code });
                }
                this.showMailEditor(this.title, null, true);
                this.mailform.setToBulkmail(null, mailAddressArray);
            break;
        }
    }

    onDelete() {

    }

    afterDelete() {

    }

    onClose() {


    }

    protected onClone(entityID: string, entity: VAM2types.EvProjectEntity_Extended) {
        let cloneForm = new EvProjectCopyForm();
        if (entity) {
            cloneForm.setup(entity, null);
        } else {
            cloneForm.setupWithId(entityID);
        }

        let dlg = new GenericDialog();

        dlg.show(cloneForm,
            "ProjectWizard__CopyEvProject",
            null,
            null,
            "okcancel",
            lang.hitch(this, this._onCloneDlgResult, cloneForm, dlg));

        dlg._setOkBtnAttr(true, false); // ok anzeigen, aber disabled

        dlg.keepOpen = true;

        cloneForm.on("result", lang.hitch(dlg, "_setOkBtnAttr", true)); // erster Parameter: anzeigen ja/nein, zweiter: enable Ja/nein
    }

    private _onCloneDlgResult(cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: number) {

        if (result <= 0) {
            dlg.close(-1, true);
            return;
        }

        let data: VAM2types.CopyFormData_EvProject = cloneForm.getData();
        //console.log("_onCloneDlgResult", data);

        dlg.disableAllButtons(true);
        this.StandbyStart(dlg.contentContainer);

        this.RequestManager.post(
            window.appRoot + "ProjectWizard/CopyEvProject",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onCopyEvProjectResponse, dlg, cloneForm),
            lang.hitch(this, this._onCopyEvProjectError, dlg)
        );
    }

    private _onCopyEvProjectResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, cloneForm: MdsLax<InstanceType<typeof EvProjectCopyForm>>, response: VAM2types.EvProjectCopyFormResponse<VAM2types.EvProjectEntity_Extended>) {

        this.StandbyStop();

        if (response.result == "success") {
            dlg.close(1, true);

            this.emit("cloned");
            topic.publish("EvProject/Cloned");

            // mit der Response eine View mit dem neuen Projekt öffnen!

            EntityHelpers.openEntityView({
                entityClass: VAMclassNames.ev_projects,
                entityId: response.data.ID,
                label: response.data.gDisp_1
            });


        }

        else {

            dlg.disableAllButtons(false);
        }
    }

    private _onCopyEvProjectError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        this.StandbyStop();

        let errorDlg = new GenericDialog();
        errorDlg.show(error.Message, this.translate("General_SavingFailed"), null, ToasterHelpers.ToasterIcons.error);

        console.error(error.Message);

        dlg.disableAllButtons(false);
    }

    private _onClick_OpenOMMatrix(){
        let id = this.entityID ?? this.entity?.ID;
        if (!id){
            return;
        }

        //code 1:1 von ProjectWizardV2
        let dlg = new GenericDialog();

        let form = new OrchestraMatrix();
        form.mainMenuGlobalSpaceNode = dlg.leftActionContainerNode; // hier kommt die OM-toolbar hin
        form.directProjectId = id;
        this.UiModder.domStyle.set(form.domNode, {
            height: "800px",
            width: "100%"
        });
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, {
            width: "80%"
        });
        dlg.setUserdefinedButton("General_Label_ViewEvProject", "", lang.hitch(this, this.showDlgAgain), true, true)
        dlg.show(form,
            this.translations["OM__SchedulerMatrix"],
            null,
            null,
            "close");
        dlg.show()
        this.UiModder.domClass.remove(dlg.leftActionContainerNode, "w3-hide");
        form.startup();
    }

    private showDlgAgain() {
        let view = new ProjectView();
        view.showAsDlg(this.entityID, this.title, this.tabContainerName, this.groupLabel);
    }

    private getProjectReport(reportName: string): void {

        switch (reportName) {
            case "projectReport":
                if (this.hasFeature("EvProject/ProjectReportOptions") === true) {

                    let optionsDlg = new ProjectReportOptionsForm();
                    optionsDlg.displayOptionsDialog(this.entityID, lang.hitch(this, this._downloadProjectReport));
                    optionsDlg.on("projectreport_cancelled", () => { this.StandbyStop(); });
                    return;
                }
                break;
        }
        

        let data = { "projectID": this.entityID, "type": reportName };

        this._downloadProjectReport(data);
    }

    private _downloadProjectReport(data: Object) {

        let url = window.appRoot + "Downloads/ProjectReport";

        this.RequestManager.callfunction(
            "Webtool_API_ProjectReport__Create",
            data,
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            true // sync
        );

        this.StandbyStart();

    }

    private _onDownloadReady(download: FileFinder.FileDescriptor) {
        this.StandbyStop();

        if (!download) {
            alert("empty result - no file to download")
        }
        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
            download.downloadKey,
            download.filename,
            download.extension);

    }

    // ### new mail stuff ###
    public enableNewMailButton = true;
    //private flagMailWasInit = false;
    mailform: MdsLax<InstanceType<typeof emailForm>>;


    // ######################

    private _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof ProjectWizard>>, result) {
        if (result <= 0) {
            dlg.close(-1, true);
        } else {
            form.save();
        }
    }

    postCreate(): void {

        this.config = {
            entityClassname: Classnames.ev_projects,
            labelProperty: "ev_project_name",
            entityClassPrintname: this.translate("General_Label_EvProject"),
            cloneOptions: {
                userroleClone: ["Projects_Create", "Projects_Edit"],
                featurePathClone: null,
            },
            editOptions: {
                userroleEdit: "Projects_Edit",
                featurePathEdit: "EvProject/ProjectWizard",
                onChangedEventName: "change",
                onDeletedEventName: "deleted",
                onSavedEventName: "saved"
            }, deleteOptions: {


                userroleDelete: "Projects_Delete",
                featurePathDelete: null,
            }
        }
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectView);
